import Auth from '@/Auth.js'

export default (to, from, next) => {
  Auth.setItem('last_route', from.path)

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Auth.isLogged()) {
      next({
        path: '/auth/login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
}
